var maptabsInit = function () {
    var mapTabs = $('[data-id="jquery-tabs-map"]');
    var map = $('[data-id="iframemap"]');

    var maptabsDesktop = function() {
        mapTabs.tabs();
        $('[data-id="mapevent-button"]').one("click", function () {

            var mapFrame = $('[data-id="iframemap"]');
            $('[data-id="iframemap"]').remove();
            $('[data-id="mapcontainer"]').append(mapFrame);
        });
    };

    var mapreloadOnResize = function() {
        var delay = (function() {
            var timer = 0;
            return function(callback, ms) {
                clearTimeout(timer);
                timer = setTimeout(callback, ms);
            };
        })();

        $(window).on('resize', function() {
            delay(function() {
                var mapFrame = $('[data-id="iframemap"]');
                $('[data-id="iframemap"]').remove();
                $('[data-id="mapcontainer"]').append(mapFrame);
            }, 500);
        });
    };

    var maptabsMobile = function() {
        mapTabs.tabs("destroy");
    };

    enquire.register("screen and (min-width:48em)", {
        match: function () {
            maptabsDesktop();
        },
        unmatch: function () {
            maptabsMobile();
        }
    }, true);

    enquire.register("screen and (max-width:64em)", {
        match: function () {
       mapreloadOnResize();
        },
        unmatch: function () {
            $(window).off("resize");
        }
    }, true);
};
